import { FinTechOpsCategories, TICKETS_LAST_UPDATED_AT_S3_PREFIX, TICKETS_S3_PREFIX } from '../../FinTechOpsConstants';
import { returnUsefulRawDataTickets } from '../../tickets/TicketsDataProcessing';
import { TicketParsedDetails, TicketsRawDataItem } from '../../tickets/TicketsInterfaces';
import { useS3Dataset, UseS3DatasetResult } from './useS3Dataset';

export const useTicketsData = (): UseS3DatasetResult<TicketParsedDetails> =>
  useS3Dataset<TicketsRawDataItem[], TicketParsedDetails>({
    prefix: TICKETS_S3_PREFIX,
    lastUpdatedPrefix: TICKETS_LAST_UPDATED_AT_S3_PREFIX,
    category: FinTechOpsCategories.tickets,
    parse: returnUsefulRawDataTickets
  });
